// Lightweight mock i18n that hardcodes Swedish strings
// Keeps the same API so existing code doesn't need changes

export const useTranslation = () => {
  return {
    t: (key: string) => key, // Return the key itself as the translation
    i18n: {
      language: 'sv-SE',
      changeLanguage: () => Promise.resolve(),
    },
  };
};

// Export empty promise for backwards compatibility
export const i18nInitPromise = Promise.resolve();

// Mock i18n object for direct imports
const i18n = {
  language: 'sv-SE',
  changeLanguage: () => Promise.resolve(),
  use: () => i18n,
  init: () => Promise.resolve(),
};

export default i18n;
